var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("section", { staticClass: "section-business" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-8 col-8 business-content" }, [
            _c("div", { staticClass: "hero-title" }, [
              _vm._v(_vm._s(_vm.$t("message.business.title")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hero-sub-title" }, [
              _vm._v(_vm._s(_vm.$t("message.business.sub_title")))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("section", { staticClass: "section-padding-gray" }, [
        _c("h2", { staticClass: "text-center" }, [
          _vm._v("ลงทะเบียนเพื่อรับส่วนลดจาก AIS")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6 offset-lg-3" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "name" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.business.contact_name")) + "*"
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactData.name,
                          expression: "contactData.name"
                        }
                      ],
                      ref: "name",
                      staticClass: "form-control input-jumbo",
                      attrs: { type: "text", id: "name", required: "" },
                      domProps: { value: _vm.contactData.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.contactData, "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "company_name" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.business.contact_company_name")
                        ) + "*"
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactData.company_name,
                          expression: "contactData.company_name"
                        }
                      ],
                      ref: "company_name",
                      staticClass: "form-control input-jumbo",
                      attrs: { type: "text", id: "company_name", required: "" },
                      domProps: { value: _vm.contactData.company_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.contactData,
                            "company_name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "email" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.business.contact_email")) + "*"
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactData.email,
                          expression: "contactData.email"
                        }
                      ],
                      ref: "email",
                      staticClass: "form-control input-jumbo",
                      attrs: { type: "email", id: "email", required: "" },
                      domProps: { value: _vm.contactData.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.contactData,
                            "email",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "tel" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.business.contact_tel")) + "*"
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactData.tel,
                          expression: "contactData.tel"
                        }
                      ],
                      ref: "tel",
                      staticClass: "form-control input-jumbo",
                      attrs: { type: "tel", id: "tel", required: "" },
                      domProps: { value: _vm.contactData.tel },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.contactData, "tel", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "promo_code" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.business.promo_code")) +
                          " (กด *545*800*14# แล้วโทรออก)"
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactData.promo_code,
                          expression: "contactData.promo_code"
                        }
                      ],
                      ref: "promo_code",
                      staticClass: "form-control input-jumbo",
                      attrs: { type: "text", id: "promo_code", required: "" },
                      domProps: { value: _vm.contactData.promo_code },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.contactData,
                            "promo_code",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button button-large button-block -cyan",
                    on: { click: _vm.sendEmail }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t(_vm.isSending)) + "\n            "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "section-padding section-solution" }, [
        _c("h2", { staticClass: "text-center" }, [
          _vm._v(_vm._s(_vm.$t("message.business.customer_title")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-8 offset-sm-2 solution-description" },
            [
              _c("p", [
                _vm._v(_vm._s(_vm.$t("message.business.customer_sub_title")))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "div",
                  {
                    staticClass: "text-center",
                    staticStyle: { "padding-top": "0.5rem" }
                  },
                  [
                    _c("h3", { staticClass: "price-city" }, [
                      _vm._v(_vm._s(_vm.$t("message.business.customer01")))
                    ])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "div",
                  {
                    staticClass: "text-center",
                    staticStyle: { "padding-top": "0.5rem" }
                  },
                  [
                    _c("h3", { staticClass: "price-city" }, [
                      _vm._v(_vm._s(_vm.$t("message.business.customer02")))
                    ])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "div",
                  {
                    staticClass: "text-center",
                    staticStyle: { "padding-top": "0.5rem" }
                  },
                  [
                    _c("h3", { staticClass: "price-city" }, [
                      _vm._v(_vm._s(_vm.$t("message.business.customer03")))
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "section-solution section-padding-gray" }, [
        _c("h2", { staticClass: "text-center" }, [
          _vm._v(_vm._s(_vm.$t("message.business.benefits_title")))
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(" ")]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-4 col-md-4 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/no-contract.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits01_title")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits01_description")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-4 col-md-4 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/adjust.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits02_title")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits02_description")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-4 col-md-4 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/receipt.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits03_title")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits03_description")))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-sm-4 col-md-4 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/protect.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits04_title")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits04_description")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-4 col-md-4 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/cleaning-equipment.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits05_title")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits05_description")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-4 col-md-4 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/saving.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits06_title")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.business.benefits06_description")))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section-partner"),
      _vm._v(" "),
      _vm._m(5)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "section-padding section-business-ais" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-8 offset-sm-2" }, [
            _c("div", { staticClass: "mb-5" }, [
              _c("img", {
                attrs: {
                  src: "/static/img/ais-logo-white.svg",
                  width: "240",
                  alt: ""
                }
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v("\n          สิทธิพิเศษเฉพาะลูกค้า AIS ภาคธุรกิจเท่านั้น"),
              _c("br"),
              _vm._v("\n          รับส่วนลด 10%\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 -white" }, [
              _vm._v("\n          เพียงกด *545*800*14# แล้วโทรออก\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 description" }, [
              _vm._v(
                "\n          จากนั้น นำรหัสส่วนลดไปกรอกที่แบบฟอร์มลงทะเบียนด้านล่าง"
              ),
              _c("br"),
              _vm._v(" "),
              _vm._v("\n          หรือติดต่อ LineID: "),
              _c("a", { attrs: { href: "https://line.me/R/ti/p/@BeNeat" } }, [
                _vm._v("@BeNeat")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-4 ais-conditions" }, [
              _c("div", [_vm._v("เงื่อนไขการรับสิทธิ์")]),
              _vm._v(" "),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "สิทธิพิเศษนี้ สำหรับลูกค้า AIS ที่เป็นสมาชิก BIZ UP เท่านั้น"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "หลังจากที่เป็นสมาชิก BIZ UP แล้วสามารถเริ่มรับสิทธิพิเศษได้ในวันถัดไป"
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("รับสิทธิ์ได้ 1 ครั้งตลอดระยะเวลาโครงการ")]),
                _vm._v(" "),
                _c("li", [_vm._v("จำนวนจำกัด 20 สิทธิ์/เดือน")]),
                _vm._v(" "),
                _c("li", [_vm._v("เฉพาะพื้นที่กรุงเทพ และ ปริมณฑล")])
              ])
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-5" }, [
      _c("div", { staticClass: "col-12 text-center" }, [
        _c("img", {
          attrs: { src: "/static/img/ais-logo.svg", width: "140", alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-image" }, [
      _c("img", { attrs: { src: "/static/img/startup-office.jpg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-image" }, [
      _c("img", { attrs: { src: "/static/img/small-office.jpeg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-image" }, [
      _c("img", { attrs: { src: "/static/img/home-office.jpeg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "section-padding-gray" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 text-center" }, [
          _c("h2", [_vm._v("ติดต่อเรา")]),
          _vm._v(" "),
          _c("div", { staticClass: "business-contact" }, [
            _c("div", { staticClass: "mb-3" }, [
              _c("i", { staticClass: "fas fa-phone-square text-primary" }),
              _vm._v(" "),
              _c("a", { attrs: { href: "tel:021131138" } }, [
                _vm._v("02-113-1138")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-3" }, [
              _c("i", { staticClass: "fas fa-envelope text-primary" }),
              _vm._v(" "),
              _c("a", { attrs: { href: "mailto:info@beneat.co" } }, [
                _vm._v("info@beneat.co")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://line.me/R/ti/p/%40hnk7011n",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      height: "38",
                      alt: "Line BeNeat",
                      src: "/static/img/btn-line.png"
                    }
                  })
                ]
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca59f1f0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca59f1f0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/BusinessAis.vue
// module id = 1529
// module chunks = 0